export function clearClientSession(): void {
  sessionStorage.clear();
  localStorage.clear();
}
